import React from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs, Crumb } from 'components/BreadCrumbs'
import { PhoneSystemList } from 'features/PhoneSystem/PhoneSystemList'

export default () => {
  return (
    <Page layout={{ header: 'app' }} title="Phone Systems">
      <PageHeader>
        <Crumbs title="Hosted Voice">
          <Crumb parent to="/dashboard/hosted-voice">
            Services
          </Crumb>
          <Crumb active>Phone Systems</Crumb>
        </Crumbs>
      </PageHeader>

      <Container paddingTop paddingBottom>
        <PhoneSystemList />
      </Container>
    </Page>
  )
}



// WEBPACK FOOTER //
// src/pages/Services/HostedVoice/PhoneSystems/PhoneSystems.tsx